const { Fragment, useEffect, useState } = wp.element;
const { __ } = wp.i18n;
const { Button, Placeholder } = wp.components;
import H5VP_Video from "../../public/elementor/singleVideo";
import Player from "../Components/Player";
import BSettings from "./../Components/BSettings";

const H5VP_Video_Obj = new H5VP_Video();

const Edit = (props) => {
  const classes = "h5vp_player ";
  const { attributes, setAttributes, clientId, isSelected } = props;
  setAttributes({ clientId });
  const { controls, source, poster, repeat, muted, popup, autoHideControl, protected: bProtected, overlay } = attributes;

  const [mediaSource, setMediaSource] = useState();
  //controls handler
  const controlsHandler = (controls) => {
    const newControls = [];
    Object.keys(controls).map((item, index) => {
      if (controls[item]) {
        newControls.push(item);
      }
    });
    return newControls;
  };

  const infos = {
    provider: "vimeo",
    video: {
      source,
      poster,
    },
    overlay,
  };
  const options = {
    controls: controlsHandler(controls),
    clickToPlay: false,
    loop: {
      active: repeat,
    },
    muted,
    hideControls: autoHideControl,
  };

  useEffect(() => {
    if (source) {
      const videoTag = document.createElement("div");
      videoTag.setAttribute("data-plyr-provider", "vimeo");
      videoTag.setAttribute("data-plyr-embed-id", source);
      videoTag.classList.add("notlibrary");
      const wrapper = document.querySelector(`#block-${clientId} .h5vp_player`);
      const videoWrapper = document.querySelector(`#block-${clientId} .h5vp_player .videoWrapper`);
      videoWrapper.innerHTML = "";
      videoWrapper.appendChild(videoTag);
      H5VP_Video_Obj.newVideo(wrapper, options, infos, true);
    }
  }, [controls, source, poster, popup]);

  const handleApply = (event) => {
    event.preventDefault();
    setAttributes({ source: mediaSource });
    // createVideo();
    setMediaSource("");
  };

  // const createVideo = () => {
  //   jQuery.post(
  //     h5vpBlock?.siteUrl + "/wp-json/h5vp/v1/video",
  //     {
  //       title: wp.data.select("core/editor").getCurrentPost().title,
  //       src: mediaSource,
  //       user_id: wp.data.select("core/editor").getCurrentPostAttribute("author"),
  //       type: "vimeo",
  //     },
  //     function (res, status) {}
  //   );
  // };

  return (
    <Fragment>
      {source ? (
        <Fragment>
          <BSettings props={props} />
          <Player classes={classes} attributes={attributes} />
        </Fragment>
      ) : (
        <Fragment>
          <Placeholder
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="html5-block-icon"
              >
                <polygon points="23 7 16 12 23 17 23 7"></polygon>
                <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
              </svg>
            }
            // instructions={__("Paste/Write a Video URL to get started.", "h5vp")}
            label={__("Paste/Write a Vimeo Video URL", "h5vp")}
          >
            <div className="h5vpUrlInput">
              <input
                type="url"
                aria-label={__("URL", "h5vp")}
                placeholder={__("Paste or type a vimeo video URL", "h5vp")}
                onChange={(src) => setMediaSource(src.target.value)}
                value={mediaSource}
              />
              <Button label={__("Apply", "h5vp")} type="submit" onClick={handleApply} isPrimary>
                {__("Apply", "h5vp")}
              </Button>
            </div>
          </Placeholder>
        </Fragment>
      )}
    </Fragment>
  );
};

export default Edit;
